
import { getLiveMapView } from "../../slice/adminMapSlice";
import useAxiosPrivate from "../useAxiosPrivate";
import { useDispatch } from "react-redux";


const useLiveDBSMLocatioins = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();
  
  const getLiveDBSMLocatioins = async (param) => {
    try {
      // console.log("useDeliveryMapData", param);
      const response = await Axios.post("get_db_sm_locations", param);
      const data = response.data;    
      dispatch(getLiveMapView(data));
      return data;  
    } catch (error) {
      console.error("Error fetching admin map data:", error);
      throw error;  
    }
  };
  return getLiveDBSMLocatioins;
};

export default useLiveDBSMLocatioins;

